import { ApiError } from "./api.js";

/**
 * Kody bledow POST /api/sessions/:id/ocena ("Oceń ponownie") jako zdania dla uzytkownika.
 *
 * Stoi obok mapowania bledow zatwierdzania podzialu (lib/podzial.ts) i ma ten sam ksztalt wyniku:
 * komunikat przy polu wyboru parametrow albo przy przycisku, plus informacja, czy trzeba pobrac
 * jeszcze raz sesje albo liste parametrow. Okno ponownej oceny wola `api.ocenPonownie`, a to
 * mapowanie zamienia odrzucenie na tekst (S-1: po ludzku, nigdy sam kod).
 */

export interface BladPonownejOceny {
  /** Przy czym stoi komunikat: wybor parametrow albo przycisk wysylki. */
  pole: "soczewki" | "ogolny";
  tekst: string;
  /** Stan sesji na serwerze jest inny niz na ekranie (np. trwa juz ocena): trzeba ja pobrac jeszcze raz. */
  odswiezSesje?: boolean;
  /** Wybor parametrow jest nieaktualny: trzeba pobrac liste jeszcze raz. */
  odswiezParametry?: boolean;
}

export function bladPonownejOceny(err: unknown): BladPonownejOceny {
  if (!(err instanceof ApiError)) {
    return { pole: "ogolny", tekst: "Nie udało się zlecić oceny. Sprawdź połączenie i spróbuj ponownie." };
  }

  switch (err.code) {
    case "brak_soczewek":
    case "zle_pole_soczewek":
      return { pole: "soczewki", tekst: "Zaznacz co najmniej jeden parametr oceny." };
    case "nieznana_soczewka":
    case "soczewka_wylaczona":
      return {
        pole: "soczewki",
        tekst: "Jeden z wybranych parametrów nie jest już dostępny. Odświeżyliśmy listę - zaznacz parametry jeszcze raz.",
        odswiezParametry: true,
      };
    case "czeka_na_zatwierdzenie":
      return {
        pole: "ogolny",
        tekst: "Ten tekst czeka na zatwierdzenie podziału na wypowiedzi. Zatwierdź podział, a ocena ruszy sama.",
        odswiezSesje: true,
      };
    case "sesja_w_trakcie_przetwarzania":
      return {
        pole: "ogolny",
        tekst: "Ta analiza jest jeszcze przetwarzana. Poczekaj, aż się skończy, i zleć ocenę ponownie.",
        odswiezSesje: true,
      };
    case "brak_transkryptu":
      return { pole: "ogolny", tekst: "Ta analiza nie ma transkryptu, więc nie ma czego oceniać." };
    case "model_niedostepny":
      return {
        pole: "ogolny",
        tekst:
          "Nie możemy teraz ocenić rozmowy, bo serwer nie ma połączenia z modelem oceny. Spróbuj ponownie później albo daj nam znać.",
      };
    case "nie_ma_takiej_sesji":
      return { pole: "ogolny", tekst: "Nie ma już tej analizy. Wróć do listy analiz." };
    default:
      return { pole: "ogolny", tekst: `Nie udało się zlecić oceny (${err.code}).` };
  }
}
